<comment-form [shopingCart]="shopingCart" [textHedaer]="'Califica al establecimiento'" #commentForm (commentFor)="OnSubmit($event)"></comment-form>